import {Injectable} from '@angular/core';
import {SelectionChangeEvent} from '@progress/kendo-angular-treelist';
import {BehaviorSubject} from 'rxjs';
import {distinctUntilChanged} from 'rxjs/operators';
import {TreeNode} from '../../models/rme/tree-node';

@Injectable()
export class TreeGridSelectorService {
  private selectedItemsSubject$ = new BehaviorSubject<TreeNode[]>([]);
  public selectedItems$ = this.selectedItemsSubject$.asObservable().pipe(distinctUntilChanged());

  public handleSelectedItemsChange(event: SelectionChangeEvent) {
    this.selectedItemsSubject$.next(event.items.map(item => item.dataItem));
  }

  public resetSelectedItems() {
    this.selectedItemsSubject$.next([]);
  }
}
